import styled from 'styled-components'
import { WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
  padding-bottom: 36px;
  width: 100%;
  margin-top: -16px;
  font-family: "Avenir Next";
  display: flex;
  flex-flow: column;
  #ump {
    margin-top: 20px;
    margin-inline: 30px;
    color: #302628;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
  }
  #measure-overdue {
    margin: 4px auto;
    display: flex;
    flex-direction: column;
    color: #c91731;
    font-family: "Avenir Next";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
  }
  #profilesList {
    display: flex;
    flex-wrap: wrap;
    background: #FFFFFF;
    padding: 24px 0 0 24px;
    border-radius: 8px;
    max-width: 642px;
    @media (max-width: 698px) {
      padding: 16px 0 0 6px;
    }
  }
  @media (max-width: 698px) {
    display: block;
  }
`

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  max-width: 480px;
  border-radius: 8px;
  background: #F7F7F7;
  margin-inline: 8px;
  padding-block: 20px 0px;
  padding-inline: 16px;
  color: #000;
  font-size: 14px;
  &>h1 {
    font-size: 20px;
    font-weight: 600;
  }
  &>p {
    margin-top: 10px;
    color: #000;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    &.note {
      margin-bottom: 0px;
      color: #625F5F;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.14px;
    }
  }
  &>button {
    width: 100%;
    padding: 10px;
    margin-block: 20px;
    display: flex;
    justify-content: center;
    border-radius: 50px;
    border: 1.5px solid #302628;
    background: #302628;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    color: ${WHITE};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
`

export const FitProfileContainer = styled.div`
  display: flex;
  padding: 6px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 6px;
  border: 1px solid #D7D1D2;
  background: #FFF;
  color: #302628;
  .section {
    width: 100%;
    margin-bottom: 4px;
    border-radius: 6px;
    background: #F7F7F7;
  }
  h6 {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 0;
    margin-right: 8px;
  }
  .header {
    font-size: 12px;
    font-weight: 600;
  }
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
  }
  .col {
    display: flex;
    flex-direction: column;
    min-width: 66px;
  }
  .label {
    font-size: 12px;
    font-weight: 600;
  }
  .value {
    font-size: 14px;
    font-weight: 400;
  }
  .moreBtn {
    rotate: 90deg;
    align-self: flex-start;
    object-fit: contain;
    height: 18px;
    margin-left: auto;
    margin-right: 10px;
    cursor: pointer;
  }
  .getMeasuredBtn {
    color: black;
    border: 1px solid black;
    background: white;
    border-radius: 25px;
    padding: 8px 28px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    font-family: Avenir;
    font-weight: 500;
    cursor: pointer;
  }
`

export const ModalContent = styled.div`
  margin: 0 0px 22px -4px;
  font-size: 16px;
  margin-block-end: 36px;
  div {
    color: black;
  }
  input, select {
    border: none;
    padding: 12px 16px;
    margin-top: 8px;
    border-radius: 8px;
    outline: 1px solid #D9D9D9;
    max-width: 334px;
    width: 100%;
  }
  select {
    border-right: 16px solid transparent;
  }
  @media (max-width: 698px) {
    margin: 16px 10px 22px -28px;
    font-size: 14px;
  }
`

export const TitleModal = styled.div`
  padding: 16px 30px;
  font-family: Avenir;
  font-weight: 500;
  border-bottom: 1px solid #D7D1D2;
  margin-bottom: 26px;
  @media (max-width: 698px) {
    padding: 16px;
  }
  #titleContainer {
    display: flex;
    align-items: center;
    i {
      font-size: 24px;
      color: #000000;
      margin-right: 16px;
    }
    span {
      font-size: 22px;
      font-weight: 600;
      @media (max-width: 698px) {
        font-size: 20px;
        font-weight: 500;
      }
    }
  }
  #userIcon {
    background: #00C7BE;
    color: white !important;
    padding: 6px;
    font-size: 16px !important;
    border-radius: 25px;
  }
  #closeModal {
    float: right;
    font-size: 26px;
    margin-top: -2px;
    cursor: pointer;
    @media (max-width: 698px) {
      font-size: 20px !important;
    }
  }
`

export const IconName = styled.div`
  border-radius: 25px;
  font-size: 12px;
  background: orange;
  width: 24px;
  text-align: center;
  padding: 4px 0px;
  margin-right: 8px;
  color: white;
  font-weight: normal;
`

export const MethodIcon = styled.img`
  margin-left: 8px;
`

export const FitCard = styled.div`
  min-width: 286px;
  margin-right: 22px;
  margin-bottom: 22px;
  @media (max-width: 698px) {
    margin-right: 10px;
    margin-bottom: 10px;
    min-width: 310px;
    width: 100%;
  }
`

export const ActionIcon = styled(Icon)``

export const EmptyCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 246px;
  background: #F7F7F7;
  border: 2px dashed #D7D1D2;
  border-radius: 6px;
  max-width: 282px;
  font-size: 16px;
  padding: 42px;
  text-align: center;
  font-weight: 500;
  color: #817E7E;
  margin-right: 22px;
  margin-bottom: 22px;
  cursor: pointer;
  .anticon {
    font-size: 40px;
    margin-bottom: 16px;
    border: 2px solid #a2a0a0;
    border-radius: 50px;
    padding: 12px;
    @media (max-width: 698px) {
      font-size: 80px;
      border-radius: 100%;
      border: 3px solid #a2a0a0;
    }
  }
  @media (max-width: 698px) {
    min-width: 320px;
    max-width: unset;
    margin-right: 10px;
    width: 100%;
  }
`

export const cancelButtonStyle = {
  border: '1.5px solid #302628',
  borderRadius: '25px',
  backgroundColor: 'white',
  fontWeight: 500,
  maxWidth: '256px',
  width: '100%',
  fontFamily: 'Avenir',
  color: '#302628',
  marginBottom: '16px',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MeasurementProfile/styledComponents.tsx